
import { storiesOf } from "@storybook/react";
import { action } from "@storybook/addon-actions";
import { withKnobs, text, number } from "@storybook/addon-knobs";
import {
  notifica,
  getUser,
  show_mdl_ldr
} from "../requests/utils";

import VideoRecorder from "react-video-recorder";
import api from "../service/api";

const handleRecordingComplete = (
  videoBlob,
  startedAt,
  thumbnailBlob,
  duration
) => {
  var bodyFormData = new FormData(),
    lbl = document.getElementById("lbl_pregunta_p_video"),
    idPregunta = lbl.getAttribute("IDPregunta"),
    lbl2 = document.getElementById("lbl_pregunta_tipo"),
    tipo = lbl2.getAttribute("tipo"),
    lbl3 = document.getElementById("lbl_pregunta_sol"),
    idSolicitud = lbl3.getAttribute("sol"),

    usr = getUser(),
    url = "",
    name = "";
  if (tipo === "TC") {
    const prestadora = document.getElementById("prestadora");
    const idPrestador = prestadora.getAttribute("prestadora");

    url = "PreguntasTecnicas/pregunta-tecnica-detalle";
    bodyFormData.set("idCandidato", usr.idCandidato);
    bodyFormData.set("idPregunta", idPregunta);
    bodyFormData.set("idSolicitud", idSolicitud);
    if (idPrestador) {
      bodyFormData.set("idPrestador", idPrestador);
    }
    name = `VideoTecnicas${usr.idCandidato}${idPregunta}`;
  } else {
    url = "estudiopsicometrico/archivo";
    name = `VideoRH${usr.idCandidato}${idPregunta}`;
    bodyFormData.set("idCandidato", usr.idCandidato);
    bodyFormData.set("idPregunta", idPregunta);
  };
  let file = new File([videoBlob], `${name}.mp4`, { type: "video/mp4" });

  bodyFormData.set("archivo", file);

  show_mdl_ldr(true);
  var vd = document.getElementById("btninitV");
  if (vd)
    vd.classList.add("Hide_Half");
  api.post(url, bodyFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
      "X-Requested-With": "XMLHttpRequest"
    }
  })
    .then(function (response) {
      show_mdl_ldr(false);
      if (response.status === 200) {
        var btn = document.getElementById("btn_grdvideo_sigue");
        btn.classList.remove("Hide_Half");
        notifica("sucess", "Se guardo Correctamente", "¡Corrrecto!");
      } else {
        document.getElementById("btnModalClose").hidden = false;
        notifica("error", response.data.message || "¡Error!", "¡Error!");
      }
    })
    .catch(function (error) {
    });

  return action("onRecordingComplete")(
    videoBlob,
    startedAt,
    thumbnailBlob,
    duration
  );

};

const actionLoggers = {
  onTurnOnCamera: action("onTurnOnCamera"),
  onTurnOffCamera: action("onTurnOffCamera"),
  onStartRecording: action("onStartRecording"),
  onStopRecording: action("onStopRecording"),
  onRecordingComplete: handleRecordingComplete,
  onOpenVideoInput: action("onOpenVideoInput"),
  onStopReplaying: action("onStopReplaying"),
  onError: action("onError")
};

const stories = storiesOf("VideoRecorder", module);
stories.addDecorator(withKnobs);

stories.addParameters({
  info: {
    components: {
      VideoRecorder
    },
    styles: {
      children: {
        height: "100%"
      }
    }
  }
});

stories.add("with default config", () => (
  <VideoRecorder
    mimeType={text("mimeType")}
    countdownTime={number("countdownTime", 3 * 1000)}
    timeLimit={number("timeLimit")}
    {...actionLoggers}
  />
));

stories.add("with isOnInitially=true", () => (
  <VideoRecorder
    isOnInitially
    mimeType={text("mimeType")}
    countdownTime={number("countdownTime", 3 * 1000)}
    timeLimit={number("timeLimit")}
    {...actionLoggers}
  />
));

stories.add("with useVideoInput=true isOnInitially=true", () => (
  <VideoRecorder isOnInitially useVideoInput {...actionLoggers} />
));

export { handleRecordingComplete };
